<template>
  <div>
    <ApplicationCard
      v-for="application in notEvaluatedApplications"
      :key="application.id"
      :application="application"
      class="m-3"
      @click="$emit('clickOrderCard', application.id)"
    />
    <p
      v-if="!notEvaluatedApplications.length"
      class="m-3 p-3 bg-white text-14 text-center"
      data-testid="noApplication"
    >
      お仕事はありません
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ApplicationCard from "@/components/organisms/applications/ApplicationCard.vue";

import { applicationStore } from "@/store/application";

@Component({
  components: {
    ApplicationCard
  }
})
export default class ApplicationsNotEvaluatedList extends Vue {
  get notEvaluatedApplications() {
    return applicationStore.notEvaluatedApplications;
  }
}
</script>
